<template>
  <v-container>
    <h2>Dátum választó:</h2>
    <date-picker @changeDates="onChangeDates"/>
    <v-row>
      Munkanapok száma: {{ workDays }}
    </v-row>

    <user-stats :dates="dates" :workDays="workDays" :userWorkStats="userWorkStats" :userWasteStats="userWasteStats" :stations="stations"/>

    <msrp-stats :dates="dates" :msrpStats="msrpStats" :workDays="workDays" :holidays="holidays" :dailyMsrp="dailyMsrp"/>
  </v-container>  
</template>
<script>

export default {
  data: () => ({
    userWorkStats: [],
    userWasteStats: [],
    msrpStats: [],
    dates: [],
    holidays: [],
  }),

  mounted() {
    this.$store.dispatch('stations/fetchStations')
  },

  computed: {
    workDays() {
      if(this.dates.length < 2) return 0

      let start = new Date(this.dates[0]);
      let end = new Date(this.dates[1]);

      if (start > end) [start, end] = [end, start];

      // Normalize recurring holidays to Set of 'MM-DD'
      const holidaySet = new Set(this.holidays.map(date => date.date.slice(-5)));

      let count = 0;
      while (start <= end) {
        const day = start.getDay();
        const mmdd = start.toISOString().slice(5, 10);

        // Weekday and not a holiday
        if (day !== 0 && day !== 6 && !holidaySet.has(mmdd)) {
            count++;
        }

        start.setDate(start.getDate() + 1);
      }

      return count;
    },

    stations() {
      return this.$store.getters['stations/stations'];
    },


    dailyMsrp() {
      let targetStation = this.stations.find(
        station => station.name === 'CSOMAGOLÁS'
      );

      if (targetStation) {
        return targetStation.expected;
      }

      return 0;
    }
  },

  methods: {
    onChangeDates(dates) {
        this.dates = dates;
        if (this.dates.length > 1) {
            this.search();
        }
    },

    async search() {
      this.$store.dispatch("loadingStatus", true);

      await axios
      .get("/stats/user-work-stats", {
          params: {
              date1: this.dates[0],
              date2: this.dates[1],
          },
      })
      .then((response) => {
          this.userWorkStats = response.data;
      })
      .catch((err) => {
          console.log(err);
      });


      await axios
      .get("/stats/user-waste-stats", {
          params: {
              date1: this.dates[0],
              date2: this.dates[1],
          },
      })
      .then((response) => {
          this.userWasteStats = response.data;
      })
      .catch((err) => {
          console.log(err);
      });


      await axios
      .get("/stats/msrp-stats", {
          params: {
              date1: this.dates[0],
              date2: this.dates[1],
          },
      })
      .then((response) => {
          this.msrpStats = response.data;
      })
      .catch((err) => {
          console.log(err);
      });


      await axios
      .get("/holidays", {})
      .then((response) => {
          this.holidays = response.data;
      })
      .catch((err) => {
          console.log(err);
      });

      this.$store.dispatch("loadingStatus", false);
    },
  }
};
</script>